import { camelCase } from '../../../config';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import IconAutomix from '../automix/svg/IconAutomix';

import { setTickItemID } from "../../../actions/index";

function TitleAction({ id, to, title }) {
  const storeRoute = useSelector(state => state.storeRoute);
  const dispatch = useDispatch();
  const goTo = () => {
    if (to) {
      storeRoute.goTo(to);
      dispatch(setTickItemID(`DI-${id}-TRACK`));
    } 
  }
  return (
    <div className={'flexRow cf-title-container'}>
      <IconAutomix />
      <span className={'type-medium fz20 cf-title-v2 ellipsis'} onClick={goTo}>{camelCase(title)}</span>
    </div>
  )
}

TitleAction.propTypes = {
  id: PropTypes.number.isRequired,
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default TitleAction;
